/* <kg-toast>: kurze Hinweise am unteren Rand, optional mit Aktion. Aufruf: document.querySelector('kg-toast').show({ message, action, onAction, duration }) oder window.kgToast(message, action, onAction). */

class KgToast extends HTMLElement {
  connectedCallback() {
    this.setAttribute('aria-live', 'polite');
    window.kgToast = (message, action, onAction, duration) => this.show({ message, action, onAction, duration });
  }

  show({ message, action, onAction, duration = 8000 } = {}) {
    if (!message) return null;
    this.hide();
    const toast = document.createElement('div');
    toast.className = 'toast';
    toast.setAttribute('role', 'status');

    const text = document.createElement('span');
    text.className = 'toast__text';
    text.textContent = message;
    toast.append(text);

    if (action) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'toast__action';
      button.textContent = action;
      button.addEventListener('click', () => {
        this.hide();
        if (typeof onAction === 'function') onAction();
      });
      toast.append(button);
    }

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'toast__close';
    close.setAttribute('aria-label', this.dataset.closeLabel || 'Close');
    close.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
    close.addEventListener('click', () => this.hide());
    toast.append(close);

    this.append(toast);
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    if (duration > 0) this.timer = window.setTimeout(() => this.hide(), duration);
    return toast;
  }

  hide() {
    window.clearTimeout(this.timer);
    const toast = this.querySelector('.toast');
    if (!toast) return;
    toast.classList.remove('is-visible');
    window.setTimeout(() => toast.remove(), 250);
  }
}

customElements.define('kg-toast', KgToast);
